module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0033.jpg?v=4aa8fb7d";